import moment from "moment";
import React, { useEffect, useState } from "react";
import Loading from "../Modals/Loading";
import { useNavigate } from "react-router-dom";
import monthlyVoucherService from "../Services/monthlyVoucher";
import Head from "../Components/Head";

const CustomerVoucher = () => {
  const [trigger, setTrigger] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const getAccounts = async () => {
      try {
        setLoading(true);
        const response = await monthlyVoucherService.fetchAllCustomers();
        setData(response.monthly_vouchers_customers);
        setLoading(false);
      } catch {}
    };
    getAccounts();
  }, [trigger]);

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <div>
          <Loading />
        </div>
      ) : (
        <div>
          <Head
            heading={"Customer Voucher"}
            button_text={"Add Customer Voucher"}
            navigation={() => navigate("/monthly/customerVoucher/add")}
          />
          {data && data.length > 0 ? (
            <div className="table-div">
              <table>
                <thead>
                  <tr className="border-y-2 text-left w-full text-black text-[10px]">
                    <th className=" rounded-tl-xl w-[2%] py-4 pl-4">
                      Start Date
                    </th>
                    <th className="w-[3%] py-4 ">End Date</th>
                    <th className="w-[2%] py-4 text-center">Customers</th>
                    <th className="w-[2%] py-4 text-center">Orders</th>
                    <th className="rounded-tr-xl w-[4%] text-center py-4">
                      Amount
                    </th>
                    <th className="rounded-tr-xl w-[4%] text-center py-4">
                      Old Balance
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((monthly_voucher, index) => (
                    <tr
                      key={index}
                      className="bg-accent border-b border-gray-100 text-left"
                    >
                      <td className="py-4 w-[2%] pl-4">
                        {moment(monthly_voucher.start_date).format('DD-MM-YYYY')}
                      </td>
                      <td className="py-4 w-[3%]">
                      {moment(monthly_voucher.end_date).format('DD-MM-YYYY')}
                      </td>
                      <td className="py-4 w-[3%] text-center font-semibold text-teal-600">
                        {monthly_voucher.company_name}
                      </td>
                      <td className="py-4 w-[3%] text-center font-semibold text-teal-600">
                        {monthly_voucher.orders}
                      </td>
                      <td className="py-4 w-[3%] text-center font-semibold text-red-500">
                        {monthly_voucher.amount}
                      </td>
                      <td className="py-4 w-[3%] text-center font-semibold text-red-500">
                        {monthly_voucher.old_balance}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="mt-20">
              <h1 className="font-bold text-2xl text-gray-700 text-center">
                No Data Found
              </h1>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomerVoucher;
